import React from 'react';

export const Home: React.FC<{}> = () => {
    return (
        <div>
            <h1>Bygr admin tool</h1>
            <div>
                <img alt="Splash" src="/images/splash.png" />
            </div>
        </div>
    );
};
